import React, { useEffect, useState } from "react";
import { Form } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import Spacer from "../../../components/layouts/Spacer";
import FloatingFormActions from "../../../components/forms/FloatingFormActions";
import {
  setChangedFormItems,
  commitChanges,
  createRecord,
} from "../houseVisitSlice";
import { getChangedItems, getFullName } from "../../../components/util/helpers";
import RestrictedContext from "../../../components/util/RestrictedContext";
import { usePermission } from "../../../hooks/accessControl";
import { useParams } from "react-router-dom";
import General from "./General";
import PatientCondition from "./PatientCondition";
import ApartmentCondition from "./ApartmentCondition";
import Satisfaction from "./Satisfaction";
import Summary from "./Summary";
import Planning from "./Planning";
import PatientDetails from "./PatientDetails";
import PreviousVisit from "./PreviousVisit";
import moment from "moment";
var flatten = require("flat");

const HouseVisitForm = (props) => {
  const { mode, hide, load } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  const dispatch = useDispatch();
  const activeHouseVisit = useSelector(
    (state) => state.houseVisit.activeHouseVisit
  );
  const saveLoading = useSelector(
    (state) => state.pendingActions["houseVisit/update"]
  );
  const changedItems = useSelector(
    (state) => state.houseVisit.changedItems.changed
  );
  const changedValues = useSelector(
    (state) => state.houseVisit.changedItems.values
  );
  const [employees, setEmployees] = useState([]);
  const profile = useSelector((state) => state.user.profile);
  const { approved } = activeHouseVisit;

  useEffect(() => {
    if (mode === "edit") {
      let name = null;
      if (activeHouseVisit.planned_employee) {
        name = getFullName(
          activeHouseVisit.planned_employee.surename,
          activeHouseVisit.planned_employee.first_name
        );
        if (activeHouseVisit.planned_employee.professional_role_id) {
          const role =
            activeHouseVisit.planned_employee.professional_role_id &&
            intl.formatMessage({
              id: `app.dataSelect.professional_role_id.${activeHouseVisit.planned_employee.professional_role_id}`,
              defaultMessage: "",
            });
          name = role ? name.concat(", ", role) : name;
        }
      }

      form.setFieldsValue({
        ...flatten(activeHouseVisit, {
          safe: true,
        }),
        planned_employee_id: name,
      });
    }
  }, [form, activeHouseVisit, mode, intl]);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const onValuesChange = (changedValues, allValues) => {
    const arr = getChangedItems(
      changedValues,
      allValues,
      changedItems,
      activeHouseVisit
    );
    if (changedValues.date && !allValues.duration_minutes) {
      form.setFieldsValue({
        ...allValues,
        duration_minutes: 15,
      });
      dispatch(
        setChangedFormItems({
          changed: [...arr, "duration_minutes"],
          values: { ...allValues, duration_minutes: 15 },
        })
      );
    } else {
      dispatch(setChangedFormItems({ changed: arr, values: allValues }));
    }
  };

  const onSubmit = async () => {
    await dispatch(mode === "edit" ? commitChanges() : createRecord());
    dispatch(load());
    hide();
  };
  const setProffesionalEmployees = (val) => {
    if (employees.length === 0 && val.length > 0) {
      setEmployees(val);
    }
  };

  let { branchId } = useParams();
  const hasPermission = usePermission(branchId, "patients", "editor");
  const enabled = !activeHouseVisit["verified"];
  const date = changedItems.includes("date")
    ? changedValues["date"]
    : activeHouseVisit["date"];
  const futureVisit =
    date && moment().endOf("day") <= moment(date).startOf("day");
  return (
    <RestrictedContext.Provider value={{ hasWritePermission: hasPermission }}>
      <Form
        layout="vertical"
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        scrollToFirstError
        onValuesChange={onValuesChange}
        form={form}
        className="formBody"
      >
        <PatientDetails activeHouseVisit={activeHouseVisit} />
        {activeHouseVisit && activeHouseVisit.previous_visit && (
          <PreviousVisit visit={activeHouseVisit.previous_visit} />
        )}
        <Planning
          enabled={enabled}
          activeHouseVisit={activeHouseVisit}
          changedValues={changedValues}
          setProffesionalEmployees={setProffesionalEmployees}
        />

        {mode === "edit" ? (
          <div>
            <General
              enabled={enabled}
              patient={activeHouseVisit.patient}
              date={changedValues["date"] || activeHouseVisit["date"]}
            />
            <PatientCondition enabled={enabled} />
            <ApartmentCondition enabled={enabled} />
            <Satisfaction enabled={enabled} />
            <Summary
              activeHouseVisit={activeHouseVisit}
              changedValues={changedValues}
              changedItems={changedItems}
              approved={approved}
              enabled={enabled}
              futureVisit={futureVisit}
              employees={employees}
            />
          </div>
        ) : null}

        <Spacer vertical={true} extra={true} />
        <FloatingFormActions
          resource={"patients"}
          action={"editor"}
          hideDelete={true}
          hideDecline={true}
          saveLoading={saveLoading}
          saveText={
            mode === "edit"
              ? intl.formatMessage({
                  id: "app.actions.saveChanges",
                })
              : intl.formatMessage({
                  id: "app.house_visits.addNewVisit",
                })
          }
          show={changedItems.length > 0}
        />
      </Form>
    </RestrictedContext.Provider>
  );
};

export default HouseVisitForm;
